<template>
  <div class="jsc-bg">
    <div class="top">
      <div class="sys-date">{{ today }}</div>
      <div class="sys-title">教学班心率驾驶舱</div>
      <div class="sys-temp"><div id="he-plugin-simple"></div></div>
    </div>
    <div>
      <my-scale @changeSize="changeSize">
        <div
          :style="{
            'margin-top': 'calc(' + mySize + 'vw' + ' + 16px',
          }"
          class="d-aligncnter d-center"
          style="width: 1920px"
        >
          <!-- 左侧班级列表 -->
          <div class="left-box">
            <div class="d-flex">
              <div class="search">
                <img class="search-img" src="@/assets/img/cockpit/down.svg" />
                <!-- <input placeholder="选择日期" class="search-input" v-model="searchDate" /> -->
                <el-date-picker
                  v-model="searchDate"
                  type="date"
                  placeholder="选择日期"
                  class="search-input"
                  prefix-icon="el-icon-dat"
                  :clearable="false"
                  @change="changeDate"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </div>
              <div class="search" style="margin-left: 12px">
                <img class="search-img" src="@/assets/img/cockpit/search.svg" />
                <input placeholder="班级/教师" class="search-input" v-model="searchKey" />
              </div>
            </div>

            <div class="class-list">
              <div
                v-for="(item, index) in classList"
                :key="'test_' + index"
                class="d-aligncnter"
                :class="classIndex == index ? 'club-box-curr' : 'club-box'"
                @click="changeClass(index)"
                v-show="ifSearchShow(item)"
              >
                <img
                  v-if="classIndex == index"
                  src="@/assets/img/cockpit/icon.svg"
                  style="width: 82px; height: 82px; margin-left: 6px"
                />
                <img v-else src="@/assets/img/cockpit/club.svg" style="width: 82px; height: 82px; margin-left: 6px" />
                <div class="d-column" style="font-size: 16px">
                  <div class="weight">{{ item.className }}</div>
                  <div>任课老师：{{ item.teacherName }}</div>
                  <div>{{ item.classTime }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 右侧班级心率详情 -->
          <div>
            <div class="d-aligncnter" style="font-size: 20px">
              <div class="d-aligncnter" style="padding: 16px" v-if="classList.length > 0">
                <img src="@/assets/img/cockpit/user.svg" style="width: 24px; height: 24px" />
                <span style="font-size: 18px; margin-left: 4px"
                  >学生心率({{ classList[classIndex].className }}) {{ searchDate }}</span
                >
              </div>
              <div class="d-aligncnter ratealltype">
                <div
                  class="rate-type d-allcenter"
                  :class="{ 'rate-type-curr': rateTypeIndex == index }"
                  v-for="(item, index) in rateTypeList"
                  :key="'rate_' + index"
                  @click="rateTypeClick(index)"
                >
                  {{ item.name }}
                </div>
                <!-- <div class="rate-type"></div>
                <div class="rate-type"></div> -->
              </div>
            </div>
            <div class="right-box-new d-column">
              <!-- <div class="d-aligncnter" style="padding: 16px 0 0 16px" v-if="classList.length > 0">
                <img src="@/assets/img/cockpit/user.svg" style="width: 24px; height: 24px" />
                <span style="font-size: 18px; margin-left: 4px"
                  >学生心率({{ classList[classIndex].className }}) {{ searchDate }}</span
                >
              </div> -->
              <div class="right-new" v-if="classList.length > 0">
                <!-- 心率 -->
                <div
                  class="each-card d-aligncnter"
                  v-for="(item, index) in stuList"
                  :key="'stu_' + index"
                  :title="item.stuName + '-' + item.stuNum + '-心率' + item.heartRate"
                  :class="getCurrBg(item)"
                >
                  <div class="card-info d-column">
                    <div class="card-name">
                      {{ item.stuName }}
                    </div>
                    <div class="card-num">{{ item.stuNum }}</div>
                  </div>
                  <div class="card-img">
                    <div class="d-allcenter img-div">
                      <img :src="getItemHeadImg(item)" />
                    </div>
                  </div>
                  <div class="card-bmp">
                    <div class="bmp">
                      {{ item.heartRate == 0 ? '--' : item.heartRate }}
                    </div>
                    <div style="font-size: 14px" class="d-aligncnter d-allcenter">
                      <img src="@/assets/img/cockpit/heart.svg" style="width: 9px; height: 8px; margin-right: 4px" />
                      bmp
                    </div>
                  </div>
                </div>

                <!-- 心率 -->
              </div>
            </div>
          </div>
        </div>
      </my-scale>
    </div>
  </div>
</template>
<script>
import MyScale from '../components/MyScale.vue'
import { getClassInfo, stuRealTimeHeartRate, getHeartRateTypeList } from '../../../api/api-heartRateCockpit'
// import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: '',
  components: {
    MyScale,

    // vueSeamlessScroll,
  },
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      timer: null,
      optionBottom: {},
      optionHeart: {},
      stuList: [],
      currStuIndex: 0,
      classIndex: 0,
      searchKey: '',
      searchDate: '',
      classList: [{ className: '', teacherName: '', classTime: '' }],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7 + 24 * 60 * 60 * 1000
        },
      },
      rateTypeList: [],
      rateTypeIndex: 0,
    }
  },
  created() {
    window.addEventListener('load', this.placeholderPic)
    window.addEventListener('resize', this.placeholderPic)
    // 时间
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 9 ? date.month : '0' + date.month
    let newday = date.date > 9 ? date.date : '0' + date.date
    this.today = date.year + '-' + newmonth + '-' + newday
    this.searchDate = this.today
  },
  computed: {
    getCurrLeft() {
      return function (index) {
        if (index > this.stuList.length / 2) {
          return -500 + 'px'
        } else {
          return ''
        }
      }
    },
    ifSearchShow() {
      return function (item) {
        if (!!item.className && !!item.teacherName) {
          if (
            !this.searchKey ||
            item.className.indexOf(this.searchKey) != -1 ||
            item.teacherName.indexOf(this.searchKey) != -1
          )
            return true
          else return false
        } else return false
      }
    },
    getCurrBg() {
      return function (item) {
        if (item.heartRate >= 140) return 'red-card'
        else if (item.heartRate >= 100) return 'yellow-card'
        else return ''
      }
    },
    getItemHeadImg() {
      return function (item) {
        if (!item.headImg) {
          if (item.gender == '男') return require('@/assets/img/cockpit/boyphoto.png')
          else {
            return require('@/assets/img/cockpit/photo.png')
          }
        } else {
          return item.headImg
        }
      }
    },
  },
  mounted() {
    this.getAllClassInfo()
    this.initRateType()
    window.onresize = () => {
      return (() => {})()
    }
    window.WIDGET = {
      CONFIG: {
        modules: '02',
        background: '5',
        tmpColor: 'FFFFFF',
        tmpSize: '16',
        cityColor: 'FFFFFF',
        citySize: '16',
        aqiColor: 'FFFFFF',
        aqiSize: '16',
        weatherIconSize: '24',
        alertIconSize: '18',
        padding: '10px 10px 10px 10px',
        shadow: '0',
        language: 'auto',
        fixed: 'false',
        vertical: 'top',
        horizontal: 'left',
        key: '18dcc59e188b4b6684d470c4322bbefa',
      },
    }
    ;(function (d) {
      var c = d.createElement('link')
      c.rel = 'stylesheet'
      c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
      var s = d.createElement('script')
      s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
      var sn = d.getElementsByTagName('script')[0]
      sn.parentNode.insertBefore(c, sn)
      sn.parentNode.insertBefore(s, sn)
    })(document)
  },
  methods: {
    initRateType() {
      getHeartRateTypeList().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getHeartRateTypeList:', res)
          this.rateTypeList = res.data.obj
          this.getStuRealTimeHeartRate()
        }
      })
    },
    rateTypeClick(index) {
      this.rateTypeIndex = index
      this.getStuRealTimeHeartRate()
    },
    getAllClassInfo() {
      getClassInfo(this.searchDate).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getClassInfo:', res)
          this.classList = res.data.obj
          this.getStuRealTimeHeartRate()
        }
      })
    },
    getStuRealTimeHeartRate() {
      stuRealTimeHeartRate(
        this.classList[this.classIndex].classId,
        this.searchDate,
        this.rateTypeList[this.rateTypeIndex].value
      ).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('stuRealTimeHeartRate:', res)
          this.stuList = res.data.obj
          //   this.stuList[0].pjxl = 141
          //   this.stuList[1].pjxl = 101
          //   this.stuList[2].pjxl = 99
        }
      })
    },
    changeCurrRace(item, index) {
      console.log('item:', item)
      this.currIndex = index
    },
    //字体大小
    placeholderPic() {
      const clientWidth = document.documentElement.clientWidth
      const n = 8 * (clientWidth / 380)
      document.documentElement.style.fontSize = n + 'px'
    },
    changeSize(size) {
      console.log('size:', size)
      this.currScale = size
      this.mySize = 5.208 / size
    },
    changeCurrStu(index) {
      this.currStuIndex = index
      var id = 'stuHeart' + index
      var myChart2 = this.$echarts.init(document.getElementById(id))
      this.optionHeart.xAxis[0].data = this.stuList[index].time
      this.optionHeart.series[0].data = this.stuList[index].heartRate
      myChart2.setOption(this.optionHeart)
    },
    changeClass(index) {
      this.classIndex = index
      this.getStuRealTimeHeartRate(this.classList[index].classId)
    },
    changeDate() {
      console.log('changeDate:', this.searchDate)
      this.searchDate = this.formatDate(this.searchDate)
      console.log('changeDate:', this.searchDate)
      this.getAllClassInfo()
      this.classIndex = 0
    },
    formatDate(date) {
      var dateObj = new Date(date)
      var year = dateObj.getFullYear().toString()
      var month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      var day = dateObj.getDate().toString().padStart(2, '0')
      var formattedDate = `${year}-${month}-${day}`
      return formattedDate
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/classheart.scss';

.jsc-bg {
  width: 100vw;
  //   min-width: 1200px;
  height: 100vh;
  //   min-height: 800px;
  overflow: hidden;
  //   background: #09120f;
  //   background: #09120f url('../../../assets/img/cockpit/home-bg.svg') no-repeat
  //     center;
  background: #09120f no-repeat center;
  color: #fff;
  user-select: none;

  .top {
    width: 100%;
    height: 5.208vw;
    background: url('../../../assets/img/cockpit/top.svg') no-repeat;
    background-size: 100%;
    position: relative;

    .sys-title {
      width: 100%;
      height: 100%;
      line-height: 5.208vw;
      vertical-align: middle;
      text-align: center;
      font-size: 1rem;
    }

    .sys-date,
    .sys-temp {
      font-size: 0.5rem;
      position: absolute;
    }

    .sys-date {
      line-height: 44px;
      top: calc(2.604vw - 18px);
      left: 6vw;
    }

    .sys-temp {
      top: calc(2.604vw - 22px);
      right: 6vw;
      display: flex;
      flex-direction: row-reverse;
    }
  }
}

.sys-temp ::v-deep .s-sticker-tmp {
  font-size: 0.5rem !important;
}

.sys-temp ::v-deep img {
  height: 0.7rem !important;
  width: 0.7rem !important;
}

.sys-temp ::v-deep #weather-view-he {
  display: none !important;
}
::-webkit-scrollbar {
  display: none;
}

.ml-16 {
  margin-left: 16px;
}
.search-input ::v-deep .el-input__inner {
  background-color: transparent;
  background-image: none;
  border: none;
  box-sizing: border-box;
  color: #757575 !important;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 120px;
}
</style>
